(function () {
  if (window.EGDrawer) return;
  window.EGDrawer = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function swapDrawer(html) {
    var cur = document.getElementById('CartDrawer');
    if (!cur || !html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
    if (!fresh) return;
    var t = cur.querySelector('.cart-drawer__title'), nt = fresh.querySelector('.cart-drawer__title');
    if (t && nt) t.textContent = nt.textContent;
    Array.prototype.slice.call(cur.children).forEach(function (c) {
      if (!c.classList.contains('cart-drawer__header')) c.remove();
    });
    Array.prototype.slice.call(fresh.children).forEach(function (c) {
      if (!c.classList.contains('cart-drawer__header')) cur.appendChild(document.importNode(c, true));
    });
  }

  function renderFreebar() {
    var bar = document.querySelector('#CartDrawer [data-eg-freebar]');
    if (!bar) return;
    var cur = bar.getAttribute('data-currency');
    var shopCur = bar.getAttribute('data-shop-currency');
    if (cur === shopCur) return;
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
    if (!rate) return;
    var threshold = Math.ceil(parseFloat(bar.getAttribute('data-threshold')) * rate) * 100;
    var total = parseInt(bar.getAttribute('data-total'), 10) || 0;
    var remaining = threshold - total;
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, maximumFractionDigits: 0 });
    } catch (e) { return; }
    var text = bar.querySelector('[data-eg-freebar-text]');
    var fill = bar.querySelector('[data-eg-freebar-fill]');
    if (text) {
      text.innerHTML = remaining > 0
        ? 'You\'re <strong>' + fmt.format(Math.ceil(remaining / 100)) + '</strong> away from free delivery'
        : 'You\'ve unlocked <strong>free delivery</strong>';
    }
    if (fill) fill.style.width = Math.min(100, threshold ? (total / threshold) * 100 : 0) + '%';
    bar.hidden = false;
  }

  function refreshFrom(d) {
    var html = d && d.sections && d.sections['cart-drawer'];
    if (html) { swapDrawer(html); return Promise.resolve(); }
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) { swapDrawer(s['cart-drawer']); });
  }

  function updateCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('CartCount');
        if (!el) return;
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      }).catch(function () {});
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }

  function done() {
    updateCount();
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function flash(btn, text) {
    btn.textContent = text;
    clearTimeout(btn._t);
    btn._t = setTimeout(function () { btn.disabled = false; btn.textContent = 'Add +'; }, 1800);
  }

  document.addEventListener('cart:updated', renderFreebar);
  if (document.readyState !== 'loading') renderFreebar();
  else document.addEventListener('DOMContentLoaded', renderFreebar);

  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#CartDrawer [data-qty-change]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    var line = parseInt(b.getAttribute('data-line'), 10);
    var qty = Math.max(0, parseInt(b.getAttribute('data-qty'), 10) || 0);
    var li = b.closest('.cart-item');
    if (li) li.classList.add('is-updating');

    post('cart/change.js', { line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
      .then(refreshFrom)
      .then(done)
      .catch(function (err) {
        if (!li) return;
        li.classList.remove('is-updating');
        var msg = li.querySelector('[data-eg-cart-msg]');
        if (msg) {
          msg.textContent = (err && err.description) || 'Something went wrong, please try again';
          msg.hidden = false;
          setTimeout(function () { msg.hidden = true; }, 3000);
        }
      })
      .then(function () { busy = false; });
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-eg-upsell-select]');
    if (!sel) return;
    sel.classList.remove('is-missing');
    var row = sel.closest('.eg-upsell__row');
    var img = row && row.querySelector('[data-eg-upsell-img]');
    if (!img) return;
    var opt = sel.options[sel.selectedIndex];
    var src = (opt && opt.getAttribute('data-image')) || img.getAttribute('data-default');
    if (src && img.getAttribute('src') !== src) {
      img.style.opacity = '0';
      var pre = new Image();
      pre.onload = pre.onerror = function () { img.src = src; img.style.opacity = '1'; };
      pre.src = src;
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-eg-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var id = btn.getAttribute('data-variant-id');
    if (!id) {
      var row = btn.closest('.eg-upsell__row');
      var sel = row && row.querySelector('[data-eg-upsell-select]');
      if (!sel || !sel.value) {
        if (sel) {
          sel.classList.remove('is-missing');
          void sel.offsetWidth;
          sel.classList.add('is-missing');
          sel.focus();
        }
        flash(btn, btn.getAttribute('data-pick') || 'Pick option');
        return;
      }
      id = sel.value;
    }

    btn.disabled = true;
    btn.textContent = 'Adding';

    post('cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname })
      .then(refreshFrom)
      .then(done)
      .catch(function (err) {
        flash(btn, err && err.status === 422 ? 'Sold out' : 'Try again');
      });
  });
})();